import { Box, Grid } from "@mui/material";
import Typography from "@mui/material/Typography";
import React, { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import MainpageChoiceBtnGroups from "../components/button_group/MainpageChoiceBtnGroup";
import "../Firebase";
import { getProfile } from "../services/PersonalService";
import { RootStoreContext } from "../store";
import classes from "./MainPage_login.module.css";

function MainPage() {
  const { PersonalStore } = useContext(RootStoreContext);
  const { updateData } = PersonalStore;
  let leftTeam = false;
  const location = useLocation();
  if (location.state) {
    leftTeam = location.state.justLeft;
  }
  useEffect(() => {
    getProfile()
      .then((value) => {
        updateData("username", value.username);
        updateData("profile_picture", value.profile_picture);
        updateData("teamid", value.teamId ? value.teamId : "");
      })
      .catch(console.log);
  }, []);

  return (
    <Box className={classes.mainpage}>
      <Grid container>
        <Grid item xs={12} className={classes.middleside}>
          <Typography varient="h1" className={classes.words}>
            嗨！現在開始挑戰susu平台的奇幻之旅吧！
          </Typography>
          <div>
            <div className={classes.MainBtn}>
              <MainpageChoiceBtnGroups
                // flexible
                btnList={["Profile", "Teamformation"]}
                leftTeam={leftTeam}
              />
            </div>
          </div>
        </Grid>
      </Grid>
    </Box>
  );
}

export default MainPage;
